module.exports = __webpack_public_path__ + "img/28_71.729e0183.png";